<template>
  <td
    :class="[
      'w-full px-2  py-1 text-center text-xs font-medium leading-5 text-gray-600 md:text-sm ',
    ]"
    style="white-space: nowrap"
  >
    <slot></slot>
  </td>
</template>

<script>
export default {
  name: "ontick-table-td",
  props: {
    align: {
      type: String,
      default: "left",
      validator: function (value) {
        return ["left", "center", "right"].indexOf(value) !== -1;
      },
    },

    active_padding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alignCustomize() {
      return {
        "text-left": this.align == "left",
        "text-center": this.align == "center",
        "text-right": this.align == "right",
      };
    },
  },
};
</script>

<style></style>
